import { Column } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Modal } from 'app/design/primitives/modal';
import { Text } from 'app/design/primitives/text';
import { isMobileNative } from 'app/utils/constants';
import { useTranslation } from 'react-i18next';
import { Linking, View } from 'react-native';

export function ModalCalendarSetting({ modalState }: { modalState: [boolean, (state: boolean) => void] }) {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = modalState;

  return (
    <Modal onClose={() => setIsOpen(false)} open={isOpen} transparent>
      <Modal.Card>
        <Modal.Title>{t('calendarModal.title', { ns: 'calendar-settings' })}</Modal.Title>

        <Column>
          <Text textAlign="center">{t('calendarModal.text', { ns: 'calendar-settings' })}</Text>
        </Column>

        <View>
          <Button
            marginBottom="spacing.general.x4"
            onPress={() => {
              if (isMobileNative) {
                void Linking.openSettings().catch(() => undefined);
              }
              setIsOpen(false);
            }}
            variant="primary"
          >
            {t('calendarModal.primaryButtonText', {
              ns: 'calendar-settings',
            })}
          </Button>

          <Button onPress={() => setIsOpen(false)} variant="secondary">
            {t('calendarModal.secondaryButtonText', {
              ns: 'calendar-settings',
            })}
          </Button>
        </View>
      </Modal.Card>
    </Modal>
  );
}
